// import {Row, Col} from "react-bootstrap";
// import React, {useState, useEffect} from 'react';
// import {useTranslation} from 'react-i18next';
// import Cookies from 'js-cookie';
// import {Checkmark} from 'react-checkmark';
// import axios from "axios";
// import Navbar from "../../Navbar";
// import Footer from "../../Footer";
// // import { useParams } from "react-router-dom";

// import { loadSanadBranding } from '../utils/loadSanadBranding';
// const { config } = require('../../api/api')

// function SanadOrderStatusByRef() {

//     const base_url = config.baseURL;
//     const [userData, setUserData] = useState(false);

//     const vendor_key= "c3VwZXJqZXRfc2FuYWRfcGVyc29uYWxfYWNjaWRlbnRfdmVuZG9yX2tleQ==";

 
//     const [refno, setRef] = useState('');

//     const [loading,setLoading]=useState(true);

//     const [OrderDetails,setOrderDetails]=useState({});

 
//   const [showIframe, setShowIframe] = useState(false);
//   const [iframeUrl, setIframeUrl] = useState("");

//      useEffect(() => {

//     loadSanadBranding();

//   }, []);
//    // ✅ Load SmartBox script
//       useEffect(() => {
//         const script = document.createElement("script");
//         script.src = config.amwalpayURL;
//         script.async = true;
//         document.body.appendChild(script);
    
//         return () => {
//           document.body.removeChild(script);
//         };
//       }, []);

 


//     const {t,i18n} = useTranslation(); 
//     const [lnstr,setlnstr] = useState("en");
    
   
        
    

//     const urlSearchString = window.location.search;

//     const uparams = new URLSearchParams(urlSearchString);
//        const reference_no =uparams.get('ref_no');
   
// //    setOrder(order);

//     useEffect(()=>{
//         if(reference_no){
//         setRef(reference_no);
//          fetchData(reference_no);
//       }
//     },[reference_no]);


   

//     const fetchData = async (order) => {
//       try {
//         const response = await fetch(
//           base_url +"/get_sanad_visa_status_refno",
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: "Bearer" + vendor_key,
//             },
//             body: JSON.stringify({ reference_no:order, }),
//           }
//         );
//         // debugger

//         if (!response.ok) throw new Error("API request failed");

//         const data = await response.json();

//         if(data.message==="success"){

//             setOrderData(data);

//              setOrderDetails(data.result.order)
//             console.log("data fetched")
//             // setUsrtok(data.result.order.access_token)
//         }
       
//       } catch (err) {
//         console.log(err.message);
//       } finally {
        
//           setTimeout(()=>{
//                    setLoading(false);
//                 },1000)
//       }
//     };

  


//    const [orderData,setOrderData]=useState([])
   
  
  
// //  const handlePayment = async (e) => {
// //         // debugger
// //         e.preventDefault();
// //         // console.log(searchResult);
// //         // console.log(searchData);
// //         setLoading(true);
// //         const rand = Math.floor(Math.random() * 90000000) + 10000000;
// //         const rnd = rand.toString();
// //         const  usrtok=orderDetails?.access_token;
// //        const data = {
// //             "order_id":orderDetails.order_id,
// //             "amount_cents": orderDetails.fee,
// //             "reference_id": rnd,
// //             "is_live": "true",
// //             "first_name": orderDetails.first_name,
// //             "last_name":orderDetails.last_name,
// //             "phone_no": orderDetails.phone,
// //             "apartment": orderDetails.apartment || "",
// //             "floor": orderDetails.floor|| "",
// //             "street": orderDetails.street || "",
// //             "city": orderDetails.city || "",
// //             "state": orderDetails.state || "",
// //             "country": orderDetails.country,
// //             "email": orderDetails.email,
// //             "save_selection": "true",
// //             "redirection_url": base_url+"/payment_status_info_sanad",
// //             "currency": orderDetails.currency,
// //             "description": "Payment visa **",
// //             "vendor_key":vendor_key
// //           };
       
// //     // debugger
// //     if (vendor_key !== ''&&usrtok!=='') {
    
// //       fetch(base_url+'/generate_payment_link_sanad', {
// //         method: 'POST',
// //         headers: {
// //           'Authorization': `Bearer ${usrtok}`,
// //           'Content-Type': 'application/json',
// //         },
// //         body: JSON.stringify(data),
// //       })
// //         .then(response => response.json())
// //         .then(data => {
// //           // debugger
// //           if(data.message==="success"){
// //             window.location.href = data.result?.client_url;
// //           }
    
// //           // setpKey(data.result.payment_token);
    
    
// //         })
// //         .catch(error => {
// //           console.error('Error posting data:', error);
// //         });
    
// //     }  
// //       };
// const handlePayment = async (e) => {
//         // debugger
//         e.preventDefault();


        
//         // console.log(searchResult);
//         // console.log(searchData);
//         setLoading(true);
//         const rand = Math.floor(Math.random() * 90000000) + 10000000;
//         const rnd = rand.toString();
//         const  usrtok=OrderDetails?.access_token;
//        const data = {
//             "order_id":OrderDetails.order_id,
//             "amount_cents": OrderDetails.fee,
//             "fee_omr": OrderDetails.fee_omr,
//             "reference_id": rnd,
//             "is_live": "true",
//             "first_name": OrderDetails.first_name,
//             "last_name":OrderDetails.last_name,
//             "phone_no": OrderDetails.phone,
//             "apartment": OrderDetails.apartment || "",
//             "floor": OrderDetails.floor|| "",
//             "street": OrderDetails.street || "",
//             "city": OrderDetails.city || "",
//             "state": OrderDetails.state || "",
//             "country": OrderDetails.country,
//             "email": OrderDetails.email,
//             "save_selection": "true",
//             "redirection_url": base_url+"/payment_status_info_sanad",
//             "currency": OrderDetails.currency,
//             "description": "Payment visa **",
//             "vendor_key":vendor_key
//           };
       
//     // debugger
//     if (vendor_key !== ''&&usrtok!=='') {
    
//       fetch(base_url+'/sanadvisapayments', {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${usrtok}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(data),
//       })
//         .then(response => response.json())
//         .then(data => {
//           setLoading(false);
//           if (data.message === "success") {
//         var parsedata = JSON.parse(data.result.payment_details)
//         const { secureHash, trxParams } = parsedata;
//         window.SmartBox.Checkout.configure = {
//           MID: trxParams.MerchantId,
//           TID: trxParams.TerminalId,
//           CurrencyId: trxParams.CurrencyId,
//           AmountTrxn: trxParams.Amount,
//           MerchantReference: trxParams.MerchantReference,
//           LanguageId: "en",
//           PaymentViewType: 1,
//           TrxDateTime: trxParams.TrxDateTime,
//           SessionToken: trxParams.SessionToken,
//           SecureHash: secureHash,
//           completeCallback: async (resp) => {
//             console.log("✅ Payment success:", resp.data);
//             setLoading(true);
//             // Verify payment
//             const verifyRes = await fetch(base_url + "/sanadvisapaymentupdate", {
//               method: "POST",
//               headers: { "Content-Type": "application/json" },
//               body: JSON.stringify(resp.data),
//             });
//             const verifyJson = await verifyRes.json();
//             if (verifyJson.valid === true) {
//               window.location.href = verifyJson.data;
//             }
//           },
//           errorCallback: (err) => {
//             setLoading(true);
//             //  window.location.href = `${config.redirectURL}/sanad-visapayment-cancel`;
//               window.location.href = `${config.redirectURL}/sanad-visa-order-status?ref_no=${OrderDetails.sanad_reference_no}`;
//             console.error("❌ Payment error:", err)
//         },
//           cancelCallback: () => {
//             console.warn("⚠️ Payment cancelled")
//         }
//         };

//         window.SmartBox.Checkout.showSmartBox();
//       }
//           // debugger
//           // if(data.message==="success"){
//           //   window.location.href = data.result?.client_url;
//           // }
    
//           // setpKey(data.result.payment_token);
    
    
//         })
//         .catch(error => {
//           console.error('Error posting data:', error);
//         });
    
//     }  
//       };
//    const closeIframe = () => {
//     setIframeUrl("");
//     setShowIframe(false);
//   };

//    const handleIframe = async () => {
  
//     const postvData1 = { email: OrderDetails.email};
  
//     if (vendor_key) {
//       try {
//         const response = await fetch(base_url + '/sanad_visa_order_download', {
//           method: 'POST',
//           headers: {
//             'Authorization': `Bearer ${vendor_key}`,
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(postvData1),
//         });
  
//         // Check if the response was successful
//         if (response.ok) {
//           const data = await response.json();
//           setIframeUrl(data?.result?.deeplink+"?iframe=true")
//           setShowIframe(true);
//         } else {
//           console.error('Error: Failed to fetch data, Status:', response.status);
//         }
//       } catch (error) {
//         console.error('Error:', error);  // This handles any errors during the fetch request
//       }
//     } else {
//       console.error('Error: vendorKey is missing or invalid');
//     }
//   };

//     return (
//       <>
       

      
//         <div className="container">
//           <div className="row d-flex align-items-center justify-content-center">

//  {orderData.message==="success" && 
//         <div className="col-lg-7 col-md-9 col-12 mt-5 " style={{marginBottom:"70px",padding:"20px",borderRadius:"10px"}}>

//         <div>
//          <div className="row mb-3">
//                                   <div className="col-lg-6 col-md-6 text-start">
//                                       <h2>Visa Application Status </h2>
//                                   </div>
//                                   <div className="col-lg-6 col-md-6 text-right">
//                                 حالة طلب التأشيرة
//                                   </div>
//                               </div>
     
//         </div>
//         <div className="inside_visa-form">
//            <div style={{display:"flex",justifyContent:"space-between"}}>
//                 {/* <h2 ></h2> */}
//                 {/* <div style={{width:"10%"}}>
//                 <img src="https://flagcdn.com/w320/au.png" style={{width:"100px"}}/>
//             </div> */}
//             </div>
            
//            <div >
//             <table >
//                 <tbody>
//                  <tr>
//                                     <td>{"Reference ID"}
//                                     </td>
//                                     <td >
//                                         :
//                                     </td>
//                                     <td className="pl-2">
//                                        {orderData.result.order.sanad_reference_no}</td>
//                                 </tr>
//                                   <tr>
//                                     <td>{"Order ID"}
//                                     </td>
//                                     <td >
//                                         :
//                                     </td>
//                                     <td className="pl-2">
//                                        {orderData.result.order.order_id}</td>
//                                 </tr>
//                  <tr>
//                                     <td >{"Order Date"}
//                                     </td>
//                                     <td>
//                                         :
//                                     </td>
//                                     <td className="pl-2">
//                                        {orderData.result.order.created_at.split("T")[0]}  </td>
//                                 </tr>
//                                  <tr>
//                                     <td>{"Order status"}
//                                     </td>
//                                     <td >
//                                         :
//                                     </td>
//                                     <td className="pl-2">
//                                          {orderData.result.order.order_status}  </td>
//                                 </tr>
                                
//                                  <tr>
//                                     <td>{"Application Status"}
//                                     </td>
//                                     <td >
//                                         :
//                                     </td>
//                                     <td className="pl-2">
//                                         {orderData.result.order.application_status}  </td>
//                                 </tr>
//                                  <tr>
//                                     <td>{"First Name"}
//                                     </td>
//                                     <td>
//                                         :
//                                     </td>
//                                     <td className="pl-2">
//                                        {orderData.result.order.first_name} </td>
//                                 </tr>
//                                  <tr>
//                                     <td >{"Last Name"}
//                                     </td>
//                                     <td>
//                                         :
//                                     </td>
//                                     <td className="pl-2">
//                                       {orderData.result.order.last_name}</td>
//                                 </tr>
//                                  <tr>
//                                     <td >{"Destination"}
//                                     </td>
//                                     <td>
//                                         :
//                                     </td>
//                                     <td className="pl-2" >
//                                       {orderData.result.order.destination}</td>
//                                 </tr>
//                                  <tr>
//                                     <td style={{
//                                         textAlign: 'left',
//                                         // width: '70%'
//                                     }}>{"Citizenship"}
//                                     </td>
//                                     <td>
//                                         :
//                                     </td>
//                                     <td className="pl-2">
//                                      {orderData.result.order.arrival}</td>
//                                 </tr>
//                                 <tr>
//                                     <td style={{
//                                         textAlign: 'left',
//                                         // width: '70%'
//                                     }}>{"Email"}
//                                     </td>
//                                     <td>
//                                         :
//                                     </td>
//                                     <td className="pl-2" style={{wordBreak: "break-word",overflowWrap: "break-word",whiteSpace: "normal"}}  >
//                                      {orderData.result.order.email}</td>
//                                 </tr>
                               
//                                 <tr>
//                                     <td style={{
//                                         textAlign: 'left',
//                                         // width: '70%'
//                                     }}>{"Payment Status"}
//                                     </td>
//                                     <td>
//                                         :
//                                     </td>
//                                     <td className="pl-2">
//                                     {orderData.result.order.payment_status} </td>
//                                 </tr>
//                                 <tr>
//                                     <td >{"Fee"}
//                                     </td>
//                                     <td style={{width:"1%"}}>
//                                         :
//                                     </td>
//                                     <td className="pl-2">
//                                      {orderData.result.order.fee_omr} OMR</td>
//                                 </tr>
//                                 </tbody>
//             </table>
           
//             </div>
//            {/* <div>
//             <table>
//             <tbody>
//              <tr style={{width:"50%"}}>
//                                     <td className="px-2">{t("Order Date")}
//                                     </td>
//                                     <td>
//                                         :
//                                     </td>
//                                     <td className="px-2">
//                                        {orderData.result.order.created_at}+"qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq  qqqqqqqqqqqqqqqqq"  </td>
//                                 </tr>
//             </tbody>
//             </table>
//            </div> */}


//            {/* {
//             (orderData.result.order.payment_status.toLowerCase() ==="success" &&
//            orderData.result.order.order_status.toLowerCase() ==="completed")&&
//             <div className="mt-3">
//                 <button type="button" onClick={handleIframe} >Download</button>
//             </div>} */}
//                   {(orderData.result.order.payment_status.toLowerCase() === "success" && <div className="mt-3">
//                     <button
//                       type="button"
//                       disabled={
//                         !(
//                           orderData.result.order.payment_status?.toLowerCase() === "success" &&
//                           orderData.result.order.order_status?.toLowerCase() === "completed"
//                         )
//                       }
//                       onClick={handleIframe}
//                       style={{
//                         backgroundColor:
//                           orderData.result.order.payment_status?.toLowerCase() === "success" &&
//                             orderData.result.order.order_status?.toLowerCase() === "completed"
//                             ? "#204974" // blue when enabled
//                             : "#ccc",   // gray when disabled
//                         color: "white",
//                         padding: "8px 16px",
//                         border: "none",
//                         borderRadius: "6px",
//                         cursor:
//                           orderData.result.order.payment_status?.toLowerCase() === "success" &&
//                             orderData.result.order.order_status?.toLowerCase() === "completed"
//                             ? "pointer"
//                             : "not-allowed",
//                       }}
//                     >
//                       Download
//                     </button>
//                   </div>)}
            
//             {
//             //(
//               orderData.result.order.payment_status.toLowerCase() !=='success' &&
//               //orderData.result.order.application_status.toLowerCase() ==='success') &&
              
//       <div className="mt-3">
//                 {/* <button type="button" onClick={handlePayment} >Make Payment</button> */}
//                 <button
//                       type="button"
//                       disabled={
//                         !(
//                           orderData.result.order.payment_status?.toLowerCase() !== "success" &&
//                           orderData.result.order.application_status?.toLowerCase() === "success"
//                         )
//                       }
//                       onClick={handlePayment}
//                       style={{
//                         backgroundColor:
//                           orderData.result.order.payment_status?.toLowerCase() !== "success" &&
//                             orderData.result.order.application_status?.toLowerCase() === "success"
//                             ? "#204974" // blue when enabled
//                             : "#ccc",   // gray when disabled
//                         color: "white",
//                         padding: "8px 16px",
//                         border: "none",
//                         borderRadius: "6px",
//                         cursor:
//                           orderData.result.order.payment_status?.toLowerCase() !== "success" &&
//                             orderData.result.order.application_status?.toLowerCase() === "success"
//                             ? "pointer"
//                             : "not-allowed",
//                       }}
//                     >
//                       Make Payment
//                     </button>
//             </div>
//             }
//             </div>
//         </div>
//            }
// </div>
//         </div>
//       {showIframe && (
//         <div className='modal'>
//           <div className = 'modal-content'style={{height: "600px" }}>
//             <h2>{t("Download")}</h2>
//             <button type="button" className="close" onClick={closeIframe}>
//           &times; 
//         </button>
//         <div>

//         <iframe
//             src={iframeUrl}
//             style={{ width: "100%", height: "500px", border: "none" }}
//             title="API Content"
//           ></iframe>

//         </div>
//           </div>
//         </div>
//       )}

//         {loading && (
//           <div className="overlay">
//             <div className="spinner"></div>
//           </div>
//         )}
       
//       </>
//     );
// }

// export default SanadOrderStatusByRef;

// SanadOrderStatusByRef_A.js
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { loadSanadBranding } from "../utils/loadSanadBranding";
const { config } = require("../../api/api");

function SanadOrderStatusByRef() {
  const base_url = config.baseURL;
  const { t } = useTranslation();

  const vendor_key =
    "c3VwZXJqZXRfc2FuYWRfcGVyc29uYWxfYWNjaWRlbnRfdmVuZG9yX2tleQ==";

  const [refno, setRef] = useState("");
  const [loading, setLoading] = useState(true);
  const [orderData, setOrderData] = useState(null);
  const [OrderDetails, setOrderDetails] = useState(null);
  const [showIframe, setShowIframe] = useState(false);
  const [iframeUrl, setIframeUrl] = useState("");
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [iframeUrl1, setIframeUrl1] = useState("");
  const [iframeUrl2, setIframeUrl2] = useState("");

  // Branding
  useEffect(() => {
    loadSanadBranding();
  }, []);

  // Safe SmartBox loader (no double load)
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.SmartBox) return; // already loaded

    const script = document.createElement("script");
    script.src = config.amwalpayURL;
    script.async = true;
    script.onload = () => console.log("SmartBox.js loaded");
    script.onerror = () =>
      console.error("Failed to load SmartBox.js. Check network or URL:", config.amwalpayURL);
    document.body.appendChild(script);
    return () => {
      // don't remove if other components might use it; safe to remove as before
      // but to be safe, remove only if script.src matches
      try {
        document.body.removeChild(script);
      } catch (e) { }
    };
  }, []);

  // Read ref_no from query
  useEffect(() => {
    const uparams = new URLSearchParams(window.location.search);
    const reference_no = uparams.get("ref_no");
    if (reference_no) {
      setRef(reference_no);
      fetchData(reference_no);
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async (reference) => {
    setLoading(true);
    try {
      const response = await fetch(base_url + "/get_sanad_visa_status_refno", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer" + vendor_key,
        },
        body: JSON.stringify({ reference_no: reference }),
      });

      if (!response.ok) throw new Error("API request failed");

      const data = await response.json();

      if (data.message === "success") {
        setOrderData(data);
        setOrderDetails(data.result.order || null);
      } else {
        setOrderData(data);
        setOrderDetails(null);
      }
    } catch (err) {
      console.error("fetchData error:", err);
    } finally {
      setTimeout(() => setLoading(false), 600);
    }
  };

  const handlePayment = async (e) => {
    e.preventDefault();
    if (!OrderDetails) return;
    setLoading(true);

    try {
      const reference = String(Math.floor(10000000 + Math.random() * 90000000));

      const payload = {
        order_id: OrderDetails.order_id,
        amount_cents: OrderDetails.fee,
        fee_omr: OrderDetails.fee_omr,
        reference_id: reference,
        is_live: "true",
        first_name: OrderDetails.first_name,
        last_name: OrderDetails.last_name,
        phone_no: OrderDetails.phone,
        apartment: OrderDetails.apartment || "",
        floor: OrderDetails.floor || "",
        street: OrderDetails.street || "",
        city: OrderDetails.city || "",
        state: OrderDetails.state || "",
        country: OrderDetails.country || "",
        email: OrderDetails.email || "",
        save_selection: "true",
        redirection_url: base_url + "/payment_status_info_sanad",
        currency: OrderDetails.currency,
        description: "Payment visa **",
        vendor_key: vendor_key,
      };

      const res = await fetch(base_url + "/sanadvisapayments", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${OrderDetails.access_token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      setLoading(false);

      if (data.message !== "success") {
        alert("Payment initialization failed.");
        return;
      }

      const parsed = JSON.parse(data.result.payment_details);
      const { secureHash, trxParams } = parsed;

      if (!window.SmartBox?.Checkout) {
        alert("Payment library not available. Please refresh and try again.");
        return;
      }

      // Call configure whether it's function or object assignment
      if (typeof window.SmartBox.Checkout.configure === "function") {
        window.SmartBox.Checkout.configure({
          MID: trxParams.MerchantId,
          TID: trxParams.TerminalId,
          CurrencyId: trxParams.CurrencyId,
          AmountTrxn: trxParams.Amount,
          MerchantReference: trxParams.MerchantReference,
          LanguageId: "en",
          PaymentViewType: 1,
          TrxDateTime: trxParams.TrxDateTime,
          SessionToken: trxParams.SessionToken,
          SecureHash: secureHash,
          completeCallback: async (resp) => {
            try {
              setLoading(true);
              const verifyRes = await fetch(base_url + "/sanadvisapaymentupdate", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(resp.data),
              });
              const verifyJson = await verifyRes.json();
              if (verifyJson.valid === true) {
                window.location.href = verifyJson.data;
              } else {
                window.location.href = `${config.redirectURL}/sanad-visa-order-status?ref_no=${OrderDetails.sanad_reference_no}`;
              }
            } catch (err) {
              console.error("Verification error:", err);
              window.location.href = `${config.redirectURL}/sanad-visa-order-status?ref_no=${OrderDetails.sanad_reference_no}`;
            }
          },
          errorCallback: (err) => {
            console.error("Payment error:", err);
            window.location.href = `${config.redirectURL}/sanad-visa-order-status?ref_no=${OrderDetails.sanad_reference_no}`;
          },
          cancelCallback: () => {
            console.warn("Payment cancelled");
            window.location.href = `${config.redirectURL}/sanad-visa-order-status?ref_no=${OrderDetails.sanad_reference_no}`;
          },
        });
      } else {
        // fallback: assignment style
        window.SmartBox.Checkout.configure = {
          MID: trxParams.MerchantId,
          TID: trxParams.TerminalId,
          CurrencyId: trxParams.CurrencyId,
          AmountTrxn: trxParams.Amount,
          MerchantReference: trxParams.MerchantReference,
          LanguageId: "en",
          PaymentViewType: 1,
          TrxDateTime: trxParams.TrxDateTime,
          SessionToken: trxParams.SessionToken,
          SecureHash: secureHash,
          completeCallback: async (resp) => {
            try {
              setLoading(true);
              const verifyRes = await fetch(base_url + "/sanadvisapaymentupdate", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(resp.data),
              });
              const verifyJson = await verifyRes.json();
              if (verifyJson.valid === true) {
                window.location.href = verifyJson.data;
              } else {
                window.location.href = `${config.redirectURL}/sanad-visa-order-status?ref_no=${OrderDetails.sanad_reference_no}`;
              }
            } catch (err) {
              console.error("Verification error:", err);
              window.location.href = `${config.redirectURL}/sanad-visa-order-status?ref_no=${OrderDetails.sanad_reference_no}`;
            }
          },
          errorCallback: (err) => {
            console.error("Payment error:", err);
            window.location.href = `${config.redirectURL}/sanad-visa-order-status?ref_no=${OrderDetails.sanad_reference_no}`;
          },
          cancelCallback: () => {
            console.warn("Payment cancelled");
            window.location.href = `${config.redirectURL}/sanad-visa-order-status?ref_no=${OrderDetails.sanad_reference_no}`;
          },
        };
      }

      // show
      try {
        window.SmartBox.Checkout.showSmartBox();
      } catch (err) {
        console.error("Error showing SmartBox:", err);
        alert("Unable to show payment window. Please try again.");
      }
    } catch (err) {
      console.error("handlePayment error:", err);
      setLoading(false);
      alert("Payment initiation error.");
    }
  };

  const handleIframe = async () => {
    if (!OrderDetails?.email) {
      alert("Missing email for download");
      return;
    }
     setIframeLoaded(false);
    setLoading(true);
    try {
      const response = await fetch(base_url + "/sanad_visa_order_download", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${vendor_key}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: OrderDetails.email }),
      });

      if (!response.ok) throw new Error("Download API failed");
          const data = await response.json();
          const parse_application = JSON.parse(OrderDetails?.applications);
          const application_status= OrderDetails?.application_status;

          const deeplink=data?.result?.deeplink;
          
          setIframeUrl1({
            deeplink: deeplink.includes("?iframe=true")?deeplink : deeplink.includes("?") ? deeplink + "&iframe=true" : deeplink + "?iframe=true",
            application_status: application_status,
            applicationId: parse_application?.[0]?.id
          });
          
          setShowIframe(true);
          // Handle the response data here

          // console.log('Response:', data);
      //   } 
      // const data = await response.json();
      // setIframeUrl((data?.result?.deeplink || "") + "?iframe=true");
      // setShowIframe(true);
    } catch (err) {
      console.error("handleIframe error:", err);
      alert("Failed to prepare download.");
    } finally {
      setLoading(false);
    }
  };

  const closeIframe = () => {
    setIframeUrl("");
    setShowIframe(false);
  };

  // Render
  return (
    <>
      <div className="container">
        <div className="row d-flex align-items-center justify-content-center">
          {orderData?.message === "success" && OrderDetails && (
            <div
              className="col-lg-7 col-md-9 col-12 mt-5"
              style={{ marginBottom: "70px", padding: "20px", borderRadius: "10px" }}
            >
              <div>
                <div className="row mb-3">
                  <div className="col-lg-6 col-md-6 text-start">
                    <h2>Visa Application Status </h2>
                  </div>
                  <div className="col-lg-6 col-md-6 text-right">حالة طلب التأشيرة</div>
                </div>

                <div className="inside_visa-form">
                  <table className="table table-borderless">
                    <tbody>
                      <tr>
                        <td>Reference ID</td>
                        <td>:</td>
                        <td>{orderData.result.order.sanad_reference_no}</td>
                      </tr>
                      <tr>
                        <td>Order ID</td>
                        <td>:</td>
                        <td>{orderData.result.order.order_id}</td>
                      </tr>
                      <tr>
                        <td>Order Date</td>
                        <td>:</td>
                        <td>{orderData.result.order.created_at?.split("T")[0]}</td>
                      </tr>
                      <tr>
                        <td>Order status</td>
                        <td>:</td>
                        <td>{orderData.result.order.order_status}</td>
                      </tr>
                      <tr>
                        <td>Application Status</td>
                        <td>:</td>
                        <td>{orderData.result.order.application_status}</td>
                      </tr>
                      <tr>
                        <td>First Name</td>
                        <td>:</td>
                        <td>{orderData.result.order.first_name}</td>
                      </tr>
                      <tr>
                        <td>Last Name</td>
                        <td>:</td>
                        <td>{orderData.result.order.last_name}</td>
                      </tr>
                      <tr>
                        <td>Destination</td>
                        <td>:</td>
                        <td>{orderData.result.order.destination}</td>
                      </tr>
                      <tr>
                        <td>Citizenship</td>
                        <td>:</td>
                        <td>{orderData.result.order.arrival}</td>
                      </tr>
                      <tr>
                        <td>Email</td>
                        <td>:</td>
                        <td style={{ wordBreak: "break-word" }}>{orderData.result.order.email}</td>
                      </tr>
                      <tr>
                        <td>Payment Status</td>
                        <td>:</td>
                        <td>{orderData.result.order.payment_status}</td>
                      </tr>
                      <tr>
                        <td>Fee</td>
                        <td>:</td>
                        <td>{orderData.result.order.fee_omr} OMR</td>
                      </tr>
                    </tbody>
                  </table>

                  {orderData.result.order.payment_status?.toLowerCase() === "success" ? (
                    <div className="mt-3">
                      <button
                        type="button"
                        disabled={
                          !(
                            orderData.result.order.payment_status?.toLowerCase() === "success" &&
                            orderData.result.order.order_status?.toLowerCase() === "completed"
                          )
                        }
                        onClick={handleIframe}
                        style={{
                          backgroundColor:
                            orderData.result.order.payment_status?.toLowerCase() === "success" &&
                              orderData.result.order.order_status?.toLowerCase() === "completed"
                              ? "#204974"
                              : "#ccc",
                          color: "white",
                          padding: "8px 16px",
                          border: "none",
                          borderRadius: "6px",
                          cursor:
                            orderData.result.order.payment_status?.toLowerCase() === "success" &&
                              orderData.result.order.order_status?.toLowerCase() === "completed"
                              ? "pointer"
                              : "not-allowed",
                        }}
                      >
                        Download
                      </button>
                    </div>
                  ) : (
                    <div className="mt-3">
                      <button
                        type="button"
                        disabled={
                          !(
                            orderData.result.order.payment_status?.toLowerCase() !== "success" &&
                            orderData.result.order.application_status?.toLowerCase() === "success"
                          )
                        }
                        onClick={handlePayment}
                        style={{
                          backgroundColor:
                            orderData.result.order.payment_status?.toLowerCase() !== "success" &&
                              orderData.result.order.application_status?.toLowerCase() === "success"
                              ? "#204974"
                              : "#ccc",
                          color: "white",
                          padding: "8px 16px",
                          border: "none",
                          borderRadius: "6px",
                          cursor:
                            orderData.result.order.payment_status?.toLowerCase() !== "success" &&
                              orderData.result.order.application_status?.toLowerCase() === "success"
                              ? "pointer"
                              : "not-allowed",
                        }}
                      >
                        Make Payment
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {showIframe && (
            <div className="modal">
              {/* <div className="modal-content" style={{ height: "600px" }}>
                <h2>{t("Download")}</h2>
                <button type="button" className="close" onClick={closeIframe}>
                  &times;
                </button>



                <iframe src={iframeUrl} style={{ width: "100%", height: "500px", border: "none" }} title="API Content" />
              </div> */}
                     <div className = 'modal-content'style={{height: "600px",width:"95%",maxWidth:'600px' }}>
            <h2>{t("Download")}</h2>
            <button type="button" className="close" onClick={closeIframe}>
          &times; 
        </button>
        <div>

        {(!iframeLoaded && iframeUrl1) && 
        <><iframe
            src={iframeUrl1?.deeplink}
            style={{ display: 'none', width: "100%", height: "500px", border: "none" }}
            title="API Content"
            onLoad={()=>{
              setIframeLoaded(true);
              if(iframeUrl1?.application_status === "success"){
              setIframeUrl2(iframeUrl1?.deeplink.split("/travellers")[0] +"/en/applications/"+iframeUrl1?.applicationId+"/details?iframe=true");
              }
              else{
                setIframeUrl2(iframeUrl1?.deeplink.split("/travellers")[0] +"/en/applications/"+iframeUrl1?.applicationId+"/step/fill_form?iframe=true");
              }
            }}
          ></iframe>
          </>}

          {/* loading */}
           {!iframeLoaded &&<>
          <div style={{ position: "absolute", top: "50%", left: "46%"}} >
            Loading...
          </div>
          </>}

           {(iframeLoaded && iframeUrl2) && 
           <>
           <iframe
            src={iframeUrl2}
            style={{ width: "100%", height: "500px", border: "none" }}
            title="API result"
            onLoad={()=>{
              setIframeLoaded(true);
            }}
          ></iframe>
          </>}

        </div>
          </div>
            </div>
          )}

          {loading && (
            <div className="overlay">
              <div className="spinner"></div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default SanadOrderStatusByRef;
